/* MAKE ROOM 2026 layout redesign — quick add, filters, sort, view toggle */
(() => {
  if (window.__mrRedesignInit) return;
  window.__mrRedesignInit = true;

  // quick-add panel toggle + variant chips (event delegation, works on all sections)
  document.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-mr-quick]');
    if (quick) {
      const card = quick.closest('[data-mr-card]');
      const panel = card && card.querySelector('[data-mr-panel]');
      if (panel) panel.hidden = !panel.hidden;
      return;
    }
    const chip = e.target.closest('[data-mr-variant]');
    if (chip && !chip.disabled) {
      const panel = chip.closest('[data-mr-panel]');
      panel.querySelectorAll('[data-mr-variant]').forEach((b) => b.classList.toggle('is-active', b === chip));
      const input = panel.querySelector('input[name="id"]');
      if (input) input.value = chip.dataset.variantId;
      const price = panel.querySelector('[data-mr-price]');
      if (price) price.textContent = chip.dataset.variantPrice;
    }
  });

  const PRICE_TESTS = {
      lt4000: (p) => p < 4000,
      '4000to10000': (p) => p >= 4000 && p <= 10000,
      '10000to100000': (p) => p > 10000 && p <= 100000,
      gt100000: (p) => p > 100000,
    };

  document.querySelectorAll('[data-mr-root]').forEach(initRoot);

  function initRoot(root) {
    const state = { type: '', price: '', artist: '' };

    function apply() {
      root.querySelectorAll('[data-mr-card]').forEach((el) => {
        const p = Number(el.dataset.price);
        let ok = (!state.type || el.dataset.type === state.type) &&
          (!state.artist || el.dataset.artist === state.artist);
        if (ok && state.price && PRICE_TESTS[state.price]) ok = PRICE_TESTS[state.price](p);
        el.hidden = !ok;
      });
      const count = root.querySelector('[data-mr-count]');
      if (count) {
        const gridPane = root.querySelector('[data-mr-viewpane="grid"]');
        const scope = gridPane || root;
        count.textContent = scope.querySelectorAll('[data-mr-card]:not([hidden])').length;
      }
    }

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-filter-type], [data-filter-price], [data-filter-artist]');
      if (!btn) return;
      let key, val;
      if (btn.dataset.filterType !== undefined) { key = 'type'; val = btn.dataset.filterType; }
      else if (btn.dataset.filterPrice !== undefined) { key = 'price'; val = btn.dataset.filterPrice; }
      else { key = 'artist'; val = btn.dataset.filterArtist; }
      const group = btn.closest('[data-mr-filtergroup]') || root;
      if (state[key] === val && val !== '') {
        // clicking the active filter again clears it
        state[key] = '';
        btn.classList.remove('is-active');
        const all = group.querySelector('[data-filter-' + key + '=""]');
        if (all) all.classList.add('is-active');
      } else {
        state[key] = val;
        group.querySelectorAll('.is-active').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      }
      apply();
    });

    const sortSel = root.querySelector('[data-mr-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', () => {
        const mode = sortSel.value;
        root.querySelectorAll('[data-mr-sortpane]').forEach((pane) => {
          const items = Array.from(pane.querySelectorAll(':scope > [data-mr-card]'));
          items.sort((a, b) => {
            if (mode === 'low') return a.dataset.price - b.dataset.price;
            if (mode === 'high') return b.dataset.price - a.dataset.price;
            if (mode === 'az') return a.dataset.title.localeCompare(b.dataset.title);
            return a.dataset.index - b.dataset.index;
          });
          items.forEach((i) => pane.appendChild(i));
        });
      });
    }

    root.querySelectorAll('[data-mr-view]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-mr-view]').forEach((b) => b.classList.toggle('is-active', b === btn));
        root.querySelectorAll('[data-mr-viewpane]').forEach((p) => {
          p.hidden = p.dataset.mrViewpane !== btn.dataset.mrView;
        });
      });
    });

    // collapse the filter rail by default on mobile
    root.querySelectorAll('[data-mr-rail]').forEach((d) => {
      if (window.matchMedia('(max-width: 989px)').matches) d.removeAttribute('open');
    });
  }
})();
